import { Box, styled, Typography } from '@mui/material';

export const NARROW_CONTAINER_QUERY = '@container (max-width: 700px)';

export const FieldWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(6),
  paddingInlineEnd: '2px',
}));

export const Row = styled(FieldWrapper)(({ theme }) => ({
  marginBottom: '24px',
}));

export const CompactFormRow = styled(FieldWrapper)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const ProfileTitle = styled(Typography)`
  color: ${({ theme }) => theme.custom?.profileTitle};
  font-size: 16px;
  font-weight: 500;
  //line-height: 24px;
  letter-spacing: -0.312px;
`;

export const EmployeeCenterContainer = styled(Box)(({ theme }) => ({
  borderRadius: '10px',
  border: `1px solid ${theme.border?.subtleBlack}`,
  background: theme.background.white,
  padding: '24px',
  overflow: 'hidden',
  marginBottom: '26px',
  boxShadow: theme.custom?.cardBoxShadow,
}));

export const EmployeeCenterTitleContainer = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.border?.subtleBlack}`,
  background: theme.background.lightGrey4,
  margin: '-24px -24px 24px -24px',
  padding: '17px 24px 17px 24px',
}));

interface ProfileTabContainerWithScrollProps {
  height?: string;
}

export const TabContainerAfterTitleWithScroll = styled(
  Box
)<ProfileTabContainerWithScrollProps>(() => ({
  width: '100%',
  height: '100vh',
  overflowY: 'scroll',
  display: 'flex',
}));

export const ProfileTabTitleContainer = styled(Box)(({ theme }) => ({
  color: theme.colors.info.text,
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: '600',
}));

export const AccrualTabTitleContainer = styled(Box)`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.text?.secondary2};
  padding-bottom: 4px;
  margin-bottom: 10px;
  border-bottom: ${({ theme }) => `1px solid ${theme?.border?.profileTitle}`};
`;
